import { render, staticRenderFns } from "./m-contact-content.vue?vue&type=template&id=5b206748&lang=pug"
import script from "./m-contact-content.vue?vue&type=script&lang=js"
export * from "./m-contact-content.vue?vue&type=script&lang=js"
import style0 from "./m-contact-content.vue?vue&type=style&index=0&id=5b206748&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports